import { signal } from '@angular/core';
import type { HttpInterceptorFn } from '@angular/common/http';
import { finalize } from 'rxjs';

const activeRequests = signal(0);

// Señal global de "hay al menos una petición HTTP en curso" — la consumirá, por ejemplo, un
// spinner en shared/layout/header. Un solo signal exportado alcanza para este tamaño de app,
// no hace falta un LoadingService dedicado.
export const isLoading = activeRequests.asReadonly();

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  activeRequests.update((count) => count + 1);
  return next(req).pipe(finalize(() => activeRequests.update((count) => Math.max(0, count - 1))));
};
